import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetClienteCpfService } from '@/features/clientes/services/get-cliente-cpf.service'
import { clientePorCpfPropostaKeys } from '@/features/clientes/utils'
import type { TCliente } from '@/shared/interfaces/cliente.types'

export const useClientePorCpfProposta = (cpf: string, enabled?: boolean): UseQueryResult<TCliente, AxiosError> => {
  return useQuery({
    queryKey: clientePorCpfPropostaKeys.obter(cpf),
    queryFn: async () => new GetClienteCpfService().execute({ cpf }).then((res) => res.data),
    enabled,
  })
}
